import type { ReactNode } from 'react';

interface PageHeroProps {
  eyebrow?: string;
  title: string;
  description?: string;
  children?: ReactNode;
  titleId?: string;
}

export function PageHero({
  eyebrow,
  title,
  description,
  children,
  titleId = 'page-hero-title',
}: PageHeroProps) {
  return (
    <section className="mb-6 sm:mb-8 lg:mb-10" aria-labelledby={titleId}>
      {eyebrow && (
        <p className="mb-2 text-xs font-semibold text-orange-400 sm:text-sm">
          {eyebrow}
        </p>
      )}
      <h1
        id={titleId}
        className="text-balance text-xl font-bold tracking-tight text-white sm:text-2xl lg:text-3xl"
      >
        {title}
      </h1>
      {description && (
        <p className="mt-2 max-w-lg text-sm leading-relaxed text-slate-400 sm:text-base">
          {description}
        </p>
      )}
      {children}
    </section>
  );
}
